// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomerInfo_container__i6s4z"};